import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertComponent } from 'src/app/alert/alert.component';
import { GrievanceDashboardService } from '../grievance-dashboard.service';

@Component({
  selector: 'app-employee-grievance-application',
  templateUrl: './employee-grievance-application.component.html',
  styleUrls: ['./employee-grievance-application.component.scss']
})
export class EmployeeGrievanceApplicationComponent {}